import Image from 'next/image';
import React from 'react';

const AboutHero = () => {
  return (
    <div className="relative h-[calc(100dvh)] w-full">
      <div className="absolute left-0 top-0 h-[calc(100dvh)] min-h-[500px] w-full">
        <Image
          src={'/img/hero.png'}
          layout={'fill'}
          alt="hero image background"
        />
      </div>
      <div className="absolute left-0 top-0 flex h-[calc(100dvh)] min-h-[500px] w-full flex-col items-center justify-center p-4">
        <div className="flex max-w-lg flex-col items-center justify-center md:max-w-3xl">
          <div className="enter-el-block bg-gradient-to-b from-uniqueFade-light via-uniqueFade-mid to-uniqueFade-dark bg-clip-text text-center font-gt-haptik text-heading-1-mobile text-transparent md:text-heading-1">
            <h1 className="leading-none">About</h1>
            <h1 className="-mt-8">OverpassIP</h1>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AboutHero;
